// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SDeUj","rootMobile":"styles_rootMobile__2F1lL"};